import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface QuickAccessCard {
  id: number;
  icon: string;
  title: string;
  description: string;
  color: string;
  bgColor: string;
}

interface QuickAccessCardsProps {
  onCardClick: (cardId: number) => void;
}

const QuickAccessCards = ({ onCardClick }: QuickAccessCardsProps) => {
  const quickAccessCards: QuickAccessCard[] = [
    {
      id: 1,
      icon: "BookOpenIcon",
      title: "Documentation",
      description: "Comprehensive technical guides and user manuals",
      color: "text-accent",
      bgColor: "bg-accent/10"
    },
    {
      id: 2,
      icon: "WrenchScrewdriverIcon",
      title: "Troubleshooting",
      description: "Step-by-step solutions for common issues",
      color: "text-conversion-accent",
      bgColor: "bg-conversion-accent/10"
    },
    {
      id: 3,
      icon: "ArrowPathIcon",
      title: "Software Updates",
      description: "Latest firmware and software releases",
      color: "text-brand-secondary",
      bgColor: "bg-brand-secondary/10"
    },
    {
      id: 4,
      icon: "ChatBubbleLeftRightIcon",
      title: "Community Forum",
      description: "Connect with practitioners and experts",
      color: "text-warning",
      bgColor: "bg-warning/10"
    }
  ];

  return (
    <section data-component-id="src/app/support-center/components/QuickAccessCards.tsx:54:4" data-component-path="src/app/support-center/components/QuickAccessCards.tsx" data-component-line="54" data-component-file="QuickAccessCards.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20bg-background%22%7D" className="py-16 bg-background">
      <div data-component-id="src/app/support-center/components/QuickAccessCards.tsx:55:6" data-component-path="src/app/support-center/components/QuickAccessCards.tsx" data-component-line="55" data-component-file="QuickAccessCards.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20lg%3Apx-8%22%7D" className="max-w-7xl mx-auto px-4 lg:px-8">
        <div data-component-id="src/app/support-center/components/QuickAccessCards.tsx:56:8" data-component-path="src/app/support-center/components/QuickAccessCards.tsx" data-component-line="56" data-component-file="QuickAccessCards.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickAccessCards.map((card) => (
            <button data-component-id="src/app/support-center/components/QuickAccessCards.tsx:58:12" data-component-path="src/app/support-center/components/QuickAccessCards.tsx" data-component-line="58" data-component-file="QuickAccessCards.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22group%20bg-white%20p-6%20rounded-xl%20border%20border-border%20hover%3Aborder-accent%20transition-all%20duration-300%20hover%3A-translate-y-2%20hover%3Ashadow-brand-md%20text-left%22%7D"
              key={card.id}
              onClick={() => onCardClick(card.id)}
              className="group bg-white p-6 rounded-xl border border-border hover:border-accent transition-all duration-300 hover:-translate-y-2 hover:shadow-brand-md text-left"
            >
              <div data-component-id="src/app/support-center/components/QuickAccessCards.tsx:63:14" data-component-path="src/app/support-center/components/QuickAccessCards.tsx" data-component-line="63" data-component-file="QuickAccessCards.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${card.bgColor} w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <Icon data-component-id="src/app/support-center/components/QuickAccessCards.tsx:64:16" data-component-path="src/app/support-center/components/QuickAccessCards.tsx" data-component-line="64" data-component-file="QuickAccessCards.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={card.icon as any} size={28} className={card.color} />
              </div>
              <h3 data-component-id="src/app/support-center/components/QuickAccessCards.tsx:66:14" data-component-path="src/app/support-center/components/QuickAccessCards.tsx" data-component-line="66" data-component-file="QuickAccessCards.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-bold%20text-text-primary%20mb-2%20group-hover%3Atext-accent%20transition-colors%20duration-300%22%7D" className="text-lg font-bold text-text-primary mb-2 group-hover:text-accent transition-colors duration-300">
                {card.title}
              </h3>
              <p data-component-id="src/app/support-center/components/QuickAccessCards.tsx:69:14" data-component-path="src/app/support-center/components/QuickAccessCards.tsx" data-component-line="69" data-component-file="QuickAccessCards.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-text-secondary%20leading-relaxed%22%7D" className="text-sm text-text-secondary leading-relaxed">
                {card.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickAccessCards;